e4.breadcrumb = {
    init: function () {
        var jBreadcrumb = jQuery( '.js-e-breadcrumb' ),
            jBreadcrumbItemAppend = jQuery( '.js-e-breadcrumb-item-append' ),
            jBreadcrumbItemGoBackLink = jQuery( '.js-e-breadcrumb-item-go-back-link' );
        if ( jBreadcrumb.length === 1 && jBreadcrumbItemAppend.length === 1 ) {
            var jBreadcrumbItemLast = jBreadcrumb.find( '.breadcrumb-item' ).last(),
                jBreadcrumbItemNew = jBreadcrumbItemLast.clone();
            jBreadcrumbItemLast.removeClass('active');
            jBreadcrumbItemNew.find( 'a' ).attr( 'href', jBreadcrumbItemAppend.data( 'link' ) );
            jBreadcrumbItemNew.find( 'span' ).text( jBreadcrumbItemAppend.data( 'text' ) );
            jBreadcrumbItemLast.after( jBreadcrumbItemNew );
        }
        if ( jBreadcrumb.length === 1 && jBreadcrumbItemGoBackLink.length === 1 ) {
            jBreadcrumb.find('.breadcrumb').append( jBreadcrumbItemGoBackLink.html() );
        }
    }
};

